/* eslint-disable import/no-unresolved,import/no-extraneous-dependencies,
import/extensions,import/no-webpack-loader-syntax */
import React, { Component, Fragment } from 'react';
// import { configureDevtool } from 'mobx-react-devtools';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter as Router } from 'react-router-redux';
import { LocaleProvider } from 'antd';
import ru_RU from 'antd/lib/locale-provider/ru_RU';

import './assets/css/index.less';

import ProtectedRoute from './Auth/components/ProtectedRoute';
import { history } from './history';


import store from './store';
import { routes } from './routes';

import AuthModule from './Auth/AuthModule';
import PageNotFound from './shared/components/PageNotFound';
import RootModule from './Root/RootModule';


class App extends Component {
  render() {
    // -- mobx tools!
    // configureDevtool({
    //   logEnabled: true,
    //   updatesEnabled: false,
    // });

    return (
      <LocaleProvider locale={ru_RU}>
        <Provider store={store}>
          <Router history={history}>
            <Fragment>
              <Switch>
                <Route key="login" path={routes.login} component={AuthModule} />
                <ProtectedRoute key="home" path={routes.home} cmp={RootModule} />
                <Route key="404" status={404} component={PageNotFound} />
              </Switch>
            </Fragment>
          </Router>
        </Provider>
      </LocaleProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js